<div class="fm-content-wrapper fm-lovedone-page">
  <div class="container-fluid">
    <div class="row">
      <div class="col-12">
        <div class="row align-items-center">
          <div class="col-sm">
            <div class="fm-page-title">
              <a routerLink="/app/scheduleprompt" class="fm-back-link mb-2">
                <span class="fm-back-link-icon"><i class="bi bi-arrow-left"></i></span>
                Back to Scheduled Prompts
              </a>
              <h2 class="fm-head-24 fm-title mb-2">{{ promptTitle() || 'Scheduled Prompts' }}</h2>
              <p class="fm-title-category mb-0">
                <i class="bi bi-tag"></i>
                {{
                  categoryName()
                    ? categoryName()
                    : 'Automate memory collection with gentle reminders'
                }}
              </p>
            </div>
          </div>
        </div>
      </div>

      <div class="col-12 mt-4 mt-sm-0">
        <!-- ── Stats Cards ─────────────────────────────────────────────── -->
        <div class="fm-cards-group">
          <div class="row g-3">
            <div class="col-sm-6 col-lg-4 col-xl-3">
              <div class="fm-white-column fm-card-icon fm-metric-card">
                <div class="fm-card-content">
                  <h3 class="fm-head-32 fm-title">{{ stats().totalSent }}</h3>
                  <p class="fm-large mb-0">Total Sent</p>
                </div>
                <div class="fm-metric-icon">
                  <img src="images/icons/fm-send.svg" class="fm-svg" alt="Total Sent" />
                </div>
              </div>
            </div>
            <div class="col-sm-6 col-lg-4 col-xl-3">
              <div class="fm-white-column fm-card-icon fm-metric-card">
                <div class="fm-card-content">
                  <h3 class="fm-head-32 fm-title">{{ stats().respondedPercent }}%</h3>
                  <p class="fm-large mb-0">Responded</p>
                </div>
                <div class="fm-metric-icon">
                  <img src="images/icons/fm-check-lg.svg" class="fm-svg" alt="Responded" />
                </div>
              </div>
            </div>
            <div class="col-sm-6 col-lg-4 col-xl-3">
              <div class="fm-white-column fm-card-icon fm-metric-card">
                <div class="fm-card-content">
                  <h3 class="fm-head-32 fm-title">{{ stats().pendingPercent }}%</h3>
                  <p class="fm-large mb-0">Pending</p>
                </div>
                <div class="fm-metric-icon">
                  <img src="images/icons/fm-pending.svg" class="fm-svg" alt="Pending" />
                </div>
              </div>
            </div>
            <div class="col-sm-6 col-lg-4 col-xl-3">
              <div class="fm-white-column fm-card-icon fm-metric-card">
                <div class="fm-card-content">
                  <h3 class="fm-head-32 fm-title">{{ stats().storiesCreated }}</h3>
                  <p class="fm-large mb-0">Stories Created</p>
                </div>
                <div class="fm-metric-icon">
                  <img src="images/icons/fm-book-lg.svg" class="fm-svg" alt="Stories Created" />
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- ── Prompt Configuration ────────────────────────────────────── -->
        @if (configuration()) {
          <div class="fm-border-column fm-card-st2">
            <div class="fm-card-head">
              <h3 class="fm-head-20 fm-card-title mb-0">Prompt Configuration</h3>
            </div>
            <div class="fm-card-body">
              <div class="row g-4">
                <div class="col-sm-6 col-lg-3">
                  <p class="fm-card-label">Frequency:</p>
                  <p class="fm-card-content fm-large">{{ configuration()!.frequencyTypeName }}</p>
                </div>
                <div class="col-sm-6 col-lg-3">
                  <p class="fm-card-label">Questions Per Prompt:</p>
                  <p class="fm-card-content fm-large">
                    {{ configuration()!.questionsPerPrompt }} Questions
                  </p>
                </div>
                <div class="col-sm-6 col-lg-3">
                  <p class="fm-card-label">Delivery Method:</p>
                  <p class="fm-card-content fm-large">
                    {{ configuration()!.deliveryMethodTypeName }}
                  </p>
                </div>
                <div class="col-sm-6 col-lg-3">
                  <p class="fm-card-label">Started On:</p>
                  <p class="fm-card-content fm-large">
                    {{ formatDate(configuration()!.startDate) }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        }

        <!-- ── Prompt History ──────────────────────────────────────────── -->
        <div class="fm-prompt-history-sec fm-border-column fm-card-st2 mt-4">
          <div
            class="fm-card-head d-flex justify-content-between align-items-center flex-wrap gap-3"
          >
            <h3 class="fm-head-20 fm-card-title mb-0">Prompt History</h3>
            <ul class="fm-history-filter mb-0">
              <li>
                <button
                  class="fm-history-filter-btn"
                  [class.active]="activeFilter() === null"
                  type="button"
                  (click)="onFilterChange(null); $event.stopPropagation()"
                >
                  All
                </button>
              </li>
              <li>
                <button
                  class="fm-history-filter-btn"
                  [class.active]="activeFilter() === 'Responded'"
                  type="button"
                  (click)="onFilterChange('Responded'); $event.stopPropagation()"
                >
                  Responded
                </button>
              </li>
              <li>
                <button
                  class="fm-history-filter-btn"
                  [class.active]="activeFilter() === 'NotResponded'"
                  type="button"
                  (click)="onFilterChange('NotResponded'); $event.stopPropagation()"
                >
                  Not Responded
                </button>
              </li>
              <li>
                <button
                  class="fm-history-filter-btn"
                  [class.active]="activeFilter() === 'Waiting'"
                  type="button"
                  (click)="onFilterChange('Waiting'); $event.stopPropagation()"
                >
                  Waiting
                </button>
              </li>
            </ul>
          </div>

          <div class="fm-card-body">
            @if (isInitializing()) {
              <div class="text-center py-5">
                <div class="spinner-border" role="status"></div>
              </div>
            } @else if (hasError()) {
              <div class="text-center py-5">
                <h4 class="fm-head-24">Something went wrong</h4>
                <p>We couldn't load the prompt history. Please try again.</p>
              </div>
            } @else if (history().length === 0) {
              <div class="text-center py-5">
                <h4 class="fm-head-24">No history found</h4>
                <p class="mb-0">Try a different filter to see available history.</p>
              </div>
            } @else {
              <div class="accordion fm-accordion" id="fmPromptHistoryAccordion">
                @for (item of history(); track item.promptNumber; let i = $index) {
                  <div
                    class="fm-history-item"
                    [attr.data-status]="item.members"
                  >
                    <!-- Timeline dot -->
                    <!-- <div class="fm-timeline-icon">
                      <span class="fm-timeline-dot">
                        <i
                          class="bi fm-timeline-icon-i"
                        ></i>
                      </span>
                    </div> -->

                    <!-- Accordion card -->
                    <div class="fm-history-box">
                      <div class="accordion-item fm-accordion-item">
                        <h2 class="accordion-header fm-accordion-header">
                          <button
                            class="accordion-button fm-accordion-button"
                            type="button"
                            data-bs-toggle="collapse"
                            [attr.data-bs-target]="'#' + getAccordionId(i)"
                            aria-expanded="true"
                            [attr.aria-controls]="getAccordionId(i)"
                          >
                            <div class="fm-history-content">
                              <div class="fm-history-top">
                                <div>
                                  <h3 class="fm-head-20 fm-history-prompt-name">
                                    Prompt #{{ item.promptNumber }}
                                  </h3>
                                  <p class="fm-history-send-date">
                                    Sent on {{ formatDate(item.sentDate) }}
                                  </p>
                                </div>
                              </div>
                            </div>
                          </button>
                        </h2>

                        <div [id]="getAccordionId(i)" class="accordion-collapse collapse show">
                          <div class="accordion-body fm-accordion-body">
                            <!-- Questions -->
                            @if (item.questions.length) {
                              <div class="fm-question-list">
                                <label class="fm-question-label">Questions Sent:</label>
                                <ol class="fm-question-items">
                                  @for (q of item.questions; track $index) {
                                    <li class="fm-question-item">{{ q }}</li>
                                  }
                                </ol>
                              </div>
                            }

                            <!-- Members -->
                            <!-- Members -->
                            @if (item.members.length) {
                              <div class="fm-prompt-footer">
                                <div class="fm-avatar-group">
                                  @for (member of item.members; track member.memberId) {
                                    <span class="fm-avatar-wrap" tabindex="0">
                                      <span
                                        class="fm-avatar"
                                        [ngClass]="getAvatarClass(member.responseStatus)"
                                      >
                                        @if (member.profilePhotoUrl) {
                                          <img
                                            [src]="member.profilePhotoUrl"
                                            [alt]="member.displayName"
                                          />
                                        } @else {
                                          {{ getMemberInitials(member.displayName) }}
                                        }
                                      </span>

                                      <span class="fm-avatar-popover">
                                        <span class="fm-avatar-popover-name">{{ member.displayName }}</span>
                                        <span
                                          class="fm-avatar-popover-status"
                                          [ngClass]="getStatusBadgeClass(member.responseStatus)"
                                        >
                                          <i
                                            class="bi fm-badge-icon"
                                            [ngClass]="getStatusBadgeIcon(member.responseStatus)"
                                          ></i>
                                          {{ getStatusLabel(member.responseStatus) }}
                                        </span>
                                        @if (member.responseDate) {
                                          <span class="fm-avatar-popover-date"
                                            >on {{ formatDate(member.responseDate) }}</span
                                          >
                                        }
                                      </span>
                                    </span>
                                  }
                                </div>
                              </div>
                            }
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                }
              </div>

              <!-- Load more spinner -->
              @if (isLoadingMore()) {
                <div class="text-center py-4">
                  <div
                    class="spinner-border"
                    role="status"
                    style="width: 1.75rem; height: 1.75rem; border-width: 3px"
                  >
                    <span class="visually-hidden">Loading more…</span>
                  </div>
                </div>
              }

              <!-- Infinite scroll sentinel -->
              @if (hasMoreHistory()) {
                <div id="historyScrollSentinel" class="fm-scroll-sentinel"></div>
              }
            }
          </div>
        </div>
        <!-- Prompt History Section End -->
      </div>
    </div>
  </div>
</div>
